function initContact(){

    (function ($) {

        function change_form(form_id) {
            $('.contact-form').hide();
            $('#form-' + form_id).show();
        }

        $('#contact_form_select').on('change', function(){
            change_form($(this).val());
        });

    })(jQuery);

}